import { EMPTY_STRING } from '../../../NonReact/constants/Common'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { ALL_VALUE } from '../../Common/API/ItemsGetters'
import { CodeTypesStringValues } from '../Constants/Constants'
import { ApplicationCodeFormData, ApplicationCodes } from '../Types/Types'

export const mapToServerState = (state: ApplicationCodeFormData, method: string): ApplicationCodes => {
    const data: ApplicationCodes = {
        Description: state?.general?.description,
        CodeType: state?.general?.codeType ?? CodeTypesStringValues.ACCOUNT_CODE,
        Code: state?.general?.code ?? EMPTY_STRING
    }

    if (state?.general?.updateExisting) {
        data.UpdateExistingItems = state.general.updateExisting
    }

    if (method === RESTMethods.PUT) {
        data.PartIDInTelSys = state?.scopeAssignment?.partition ?? ALL_VALUE
        data.TelSysID = Number(state?.scopeAssignment?.telephonyServer ?? ALL_VALUE)
    }

    return data
}
